import { api } from "@/api/client";

export interface TwoFactorStatus {
  enabled: boolean;
  recovery_codes_remaining: number;
  // Faux pour un compte cree par OAuth, qui n'a pas de mot de passe a confirmer.
  password_required: boolean;
}

export interface TwoFactorSetup {
  secret_b32: string;
  otpauth_url: string;
}

export interface TwoFactorRecoveryCodes {
  recovery_codes: string[];
}

export const twoFactorApi = {
  status() {
    return api<TwoFactorStatus>("/auth/2fa/status");
  },
  // Le mot de passe courant est exige quand le compte en a un: activer un second facteur
  // ENFERME le compte, et un jeton d'acces vole suffisait a poser l'authenticator d'un
  // attaquant (la victime doit ensuite fournir un code qu'elle n'a pas, et rien ne sait
  // retirer un TOTP). Vide pour un compte OAuth, qui n'a pas de mot de passe.
  setup(currentPassword = "") {
    return api<TwoFactorSetup>("/auth/2fa/setup", {
      method: "POST",
      body: { current_password: currentPassword },
    });
  },
  confirm(code: string) {
    return api<TwoFactorRecoveryCodes>("/auth/2fa/confirm", {
      method: "POST",
      body: { code },
    });
  },
  disable(code: string) {
    return api<void>("/auth/2fa/disable", { method: "POST", body: { code } });
  },
  // Requires a second factor, exactly like `disable`. Regenerating recovery
  // codes mints a fresh permanent 2FA bypass, so a bare session token must not
  // be enough: a stolen access token would otherwise BE the second factor.
  regenerate(code: string) {
    return api<TwoFactorRecoveryCodes>("/auth/2fa/recovery_codes", {
      method: "POST",
      body: { code },
    });
  },
  loginWith(temp_token: string, code: string) {
    return api<{ access_token: string; expires_in: number; refresh_token: string }>(
      "/auth/2fa/login_2fa",
      { method: "POST", body: { temp_token, code }, anonymous: true },
    );
  },
};
